/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {React, useEffect} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import {iniciarAnaliticas} from "../Servicios/Analiticas/iniciarAnaliticas";
import Boletines from "./Secciones/Boletines";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Main from "./Secciones/Main";
import Checking from "./Secciones/Checking";
import Seccion_Detalle from "./Secciones/Seccion_Detalle";
import {Grid} from "@mui/material";


const Pagina = () => {


    useEffect(() => {
        AOS.init({
            offset: 0
        });
        AOS.refresh();


        iniciarAnaliticas()

    }, []);


    return (
        <Router>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start'}}>

            </Grid>

            <Routes>

                <Route path={"/Boletines/:id"} element={<Boletines/>}/>
                <Route path={"/Home"} element={<Main/>}/>
                <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                <Route path={"/Checking/:id"} element={<Checking/>}/>
                <Route path={"/*"} element={<Main/>}/>


            </Routes>

        </Router>

    )
}

export default Pagina;

